module.exports = __webpack_public_path__ + "img/ChartHinzufügen.c57d9ace.png";